import { render } from "./UploadStudentDialog.vue?vue&type=template&id=1f808f82"
import script from "./UploadStudentDialog.vue?vue&type=script&lang=js"
export * from "./UploadStudentDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__